const DEFAULT_DATASET_KEY = "project1";

const PROJECT_STRUCTURE_URL = new URL(
  "../extract/project1-structure.json",
  import.meta.url
).href;

const STUDY_EXTRACT_URLS = [
  new URL("../extract/project1-study1-extract.json", import.meta.url).href,
  new URL("../extract/project1-study2-extract.json", import.meta.url).href,
  new URL("../extract/project1-study3-extract.json", import.meta.url).href
];

const DOCUMENT_WORKING_URL = new URL(
  "../extract/document-working1.json",
  import.meta.url
).href;

const DOCUMENT_EXTRACT_URL = new URL(
  "../extract/document-extract1.json",
  import.meta.url
).href;

export function deriveDatasetKey(_: string | undefined | null): string {
  return DEFAULT_DATASET_KEY;
}

export function getProjectStructureUrl(_: string): string {
  return PROJECT_STRUCTURE_URL;
}

export function getStudyExtractUrl(datasetKey: string, studyName?: string): string {
  // If studyName is provided, map it to the correct extract file
  if (studyName) {
    const normalizedStudyName = studyName.toUpperCase().trim();
    if (normalizedStudyName === 'MATTERHORN') {
      return STUDY_EXTRACT_URLS[0]; // project1-study1-extract.json
    } else if (normalizedStudyName === 'EVEREST') {
      return STUDY_EXTRACT_URLS[1]; // project1-study2-extract.json
    }
    // For other study names, default to first URL
  }
  // Default to first URL if no study name provided
  return STUDY_EXTRACT_URLS[0];
}

export function getStudyExtractUrls(_: string): string[] {
  return STUDY_EXTRACT_URLS;
}

export function getDocumentWorkingUrl(_: string): string {
  return DOCUMENT_WORKING_URL;
}

export function getDocumentExtractUrl(_: string): string {
  return DOCUMENT_EXTRACT_URL;
}

